import { useSearchParams, Link } from "react-router-dom";
import Navbar from "../components/Navbaar";
import Footer from "../components/Footer";
import SEO from "../components/SEO/SEO";
import BookingForm from "../components/BookingForm";
import { findService } from "../data/services";
import styles from "./Booking.module.css";

function Booking() {
  const [searchParams] = useSearchParams();
  const requested = searchParams.get("service") || "";
  const initialService = findService(requested) ? requested : "";

  return (
    <>
      <SEO
        title="Book a Service | BOI Gardens & Car Cleaning"
        description="Book gardening or car cleaning in Kerikeri, New Zealand."
      />

      <Navbar />

      <main className={styles.page}>
        <div className={styles.bg} aria-hidden="true" />

        <div className={styles.wrap}>
          <div className={styles.head}>
            <span className="eyebrow">Book a service</span>
            <h1>Tell us what you need</h1>
            <p>
              Fill this in and we'll text or call to confirm the details —
              no account, no payment upfront.
            </p>
          </div>

          <BookingForm initialService={initialService} />

          <p className={styles.altContact}>
            Prefer to talk first? <Link to="/contact">Contact us directly</Link>.
          </p>
        </div>
      </main>

      <Footer />
    </>
  );
}

export default Booking;
